import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IExpenseConfigAllocation {
    customerId: string;
    customerName: string;
    classId: string;
    className: string;
    locationId: string;
    locationName: string;
    percentage: number;
}

export interface IOneOffConfigurations {
    accountIds: string[];
    customerIds: string[];
    classIds: string[];
    locationIds: string[];
    vendorIds?: string[];
    expenseConfigAllocations: IExpenseConfigAllocation[];
    isSingleAccountAllocation?: boolean; // Optional flag for single account mode
    configAccount?: { name: string; value: string } | null; // Optional account replacement
}

const initialState: {
    oneOffConfigurations: IOneOffConfigurations | null;
} = {
    oneOffConfigurations: null,
};

const oneOffSlice = createSlice({
    name: 'oneOff',
    initialState,
    reducers: {
        updateOneOffConfigurations: (
            state,
            action: PayloadAction<Partial<IOneOffConfigurations>>
        ) => {
            if (state.oneOffConfigurations) {
                state.oneOffConfigurations = {
                    ...state.oneOffConfigurations,
                    ...action.payload,
                };
            } else {
                state.oneOffConfigurations = {
                    accountIds: [],
                    customerIds: [],
                    classIds: [],
                    locationIds: [],
                    vendorIds: [],
                    expenseConfigAllocations: [],
                    ...action.payload,
                };
            }
        },
        clearOneOffConfigurations: (state) => {
            state.oneOffConfigurations = null;
        },
    },
});

export const { updateOneOffConfigurations, clearOneOffConfigurations } =
    oneOffSlice.actions;
export default oneOffSlice;

